// extracted by mini-css-extract-plugin
module.exports = {"p1i23nbj":"p1i23nbj","s1h9buau":"s1h9buau","s1rfmxz9":"s1rfmxz9"};